


































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import { format, parseISO, addDays, getHours, getMinutes, set } from "date-fns";

import ModalTabs from "../../DashboardLayoutComponents/ModalTabs.vue";
import FormField from "../../DashboardLayoutComponents/FormField.vue";
import EspressoAux from '../../../components/Espresso/EspressoAux.vue';

import ShiftCard from "@/layouts/DashboardLayoutComponents/ShiftCard.vue";

import shiftModel from "@/models/shift.model";

@Component({
	components: { ModalTabs, FormField, ShiftCard, VueperSlides, VueperSlide },
})
export default class CopyModal extends Vue {
	tabs = [
		{ icon: "playlist_add", name: "Replicar", actionName: "Replicar plantões", action: this.copyShifts },
	];

	@Prop() calendarDays: any[];

	calendarDaysLocal: any[] = [];
	auditNotes: string = "";

	constructor() {
		super();
	}

	private async mounted() {
		this.calendarDaysLocal = this.calendarDays.map(calendarDay => ({ ...calendarDay, copyDates: [{ dateString: addDays(parseISO(calendarDay.shifts[0].startDateTime), 7).toISOString() }] }));
	}

	updateNotes(notes: string) {
		this.auditNotes = notes;
	}

	addCopyDate(calendarDay: any) {
		if (calendarDay.copyDates.length) {
			const dateString = addDays(parseISO(calendarDay.copyDates[calendarDay.copyDates.length - 1].dateString), 7).toISOString();
			calendarDay.copyDates.push({ dateString });
		}
	}

	handleCopyDateDeleteClick(dateIndex: number, calendarDayIndex: number) {
		const calendarDayToDeleteFrom = this.calendarDaysLocal[calendarDayIndex];
		calendarDayToDeleteFrom.copyDates.splice(dateIndex, 1);
	}

	private async copyShifts() {
		for (const calendarDay of this.calendarDaysLocal) {
			for (const shift of calendarDay.shifts.filter((shift: any) => shift.isSelected)) {
				const shiftDateFormatted = format(parseISO(shift.startDateTime), "dd/MM/yyyy HH:mm");
				const sourceStartDateTime = parseISO(shift.startDateTime);
				const shiftHoursMinutes = {
					hours: getHours(sourceStartDateTime),
					minutes: getMinutes(sourceStartDateTime),
				};
				const startDateTimes = calendarDay.copyDates.map((date: any) => set(parseISO(date.dateString), shiftHoursMinutes).toISOString());

				const copiedShifts = startDateTimes.map((startDateTime: any) => ({
					...shift,
					startDateTime,
					id: null,
					state: shift["professionalUser.id"] ? 'PENDING' : 'STANDBY',
					checkInDateTime: null,
					checkOutDateTime: null,
					actualDurationTime: null,
					events: [],
					auditNotes: this.auditNotes,
					attendanceStatus: undefined,
				}));
				try {
					for (const copiedShift of copiedShifts) {
						await shiftModel.create(copiedShift);
					}
					this.$toasted.success(`Plantão do dia ${shiftDateFormatted} foi replicado`);
				} catch (error) {
					this.$toasted.error(`Não foi possível replicar o plantão do dia ${shiftDateFormatted}`);
					console.error(error);
				}
			}
		}
		this.$emit("close");
	}
}
